import DvhChart from "@pages/PhysicianReview/components/DVHChart";

import { Card, CardHeader, Divider, Typography } from "@mui/material";
import CustomCardContent from "./CustomCardContent";
import { DvhChartData } from "@providers/hop-ord-server/api";

interface Props {
  scorecardAttachmentsLoading: boolean;
  dvhData?: DvhChartData | null;
}
const DVHCard = ({ scorecardAttachmentsLoading, dvhData }: Props) => {
  return (
    <Card variant="outlined">
      <CardHeader
        title={<Typography variant="h6">Dose Volume Histogram</Typography>}
        subheader={"Dose Volume Histograms for targets and organs at risk."}
      />
      <Divider />
      <CustomCardContent
        isLoading={scorecardAttachmentsLoading}
        isEmpty={!dvhData}
        contentDisplayType="dose volume histogram"
      >
        {dvhData && <DvhChart data={dvhData} />}
      </CustomCardContent>
    </Card>
  );
};

export default DVHCard;
